// Client-side helpers for sending Intercom events and contact-attribute
// updates through our own backend (which forwards to the Intercom REST API
// with a server-side access token).
//
// These replace direct window.Intercom('trackEvent'|'update', ...) calls for
// analytics/contact data. window.Intercom is now used only for Messenger
// concerns: identity ({ user_id, user_hash }), boot/shutdown, showSpace/
// showArticle, and launcher visibility (hide_default_launcher).
//
// Both helpers are fire-and-forget: they resolve to null on any failure so an
// Intercom sync problem (including an anonymous visitor with no session) can
// never break the UX.

import {
  trackIntercomEvent as trackIntercomEventApi,
  updateIntercomUser as updateIntercomUserApi,
} from './api';

export const trackIntercomEvent = (eventName, metadata = {}) =>
  trackIntercomEventApi({ eventName, metadata }).catch(() => null);

export const updateIntercomUser = attributes =>
  updateIntercomUserApi({ attributes }).catch(() => null);

// Messenger language for a user, derived from their notificationLanguage
// ('finnish' | 'english'). Intercom picks the Messenger/Fin/workflow language
// as language_override → detected → browser language, and its REST API ignores
// language_override, so it can only be set through window.Intercom. Returns
// undefined when unknown so the browser language still applies.
const MESSENGER_LANGUAGES = { finnish: 'fi', english: 'en' };

export const intercomLanguageOverride = user =>
  MESSENGER_LANGUAGES[user?.attributes?.profile?.privateData?.notificationLanguage];
